import { Factory } from 'fishery'
import {
  type OpalApiComponent,
  type OpalApiResponseDocument,
} from '@opallabs/api'
import { linkageFromResource } from '@opallabs/json-api'
import { workflowAssignmentResourceFactory } from '../resource_objects/workflow_assignment'
import { workflowStageResourceFactory } from '../resource_objects/workflow_stage'

type WorkflowStage = OpalApiResponseDocument<'ReadWorkflowStageV3', 200>
type Assignment = OpalApiComponent<'V3', 'workflow_assignment'>

type WorkflowStageTransientParams = {
  /** @default one unassigned task assignment */
  assignments: Array<Assignment>
}

/** `ReadWorkflowStageV3` with `include=assignments`. */
export const workflowStageFactory = Factory.define<
  WorkflowStage,
  WorkflowStageTransientParams
>(({ transientParams, params }) => {
  const stage = workflowStageResourceFactory.build(params.data)
  const assignments = (
    transientParams.assignments ?? [workflowAssignmentResourceFactory.build()]
  ).map((assignment) => ({
    ...assignment,
    attributes: {
      ...assignment.attributes,
      assignment_type: stage.attributes.stage_type,
    },
    relationships: {
      ...assignment.relationships,
      stage: linkageFromResource(stage),
    },
  }))
  stage.relationships.assignments = linkageFromResource(assignments)

  return { data: stage, included: assignments } satisfies WorkflowStage
})
